import { User } from "lucide-react";
import { t, useLocale } from "@/i18n/locale";
import type { DiscoverDeveloper } from "../discoverClient";

const AVATAR = 20;

/**
 * Who posted the app on ato.run, for the Grid card. Only a `publisher` is
 * shown: an upstream author (`repository_owner`, `author`, `modifier`) is not
 * the poster, so it is left to the details page rather than presented here as
 * one. Without a publisher the card shows no person at all; nothing is
 * invented. Avatar and name are one link to the same profile.
 */
export default function PublisherByline({ developers, onNavigate }: {
  developers: readonly DiscoverDeveloper[];
  onNavigate?: (route: string) => void;
}) {
  useLocale();
  const publisher = developers.find((developer) => developer.role === "publisher");
  if (!publisher) return null;
  const internal = publisher.profile_url.startsWith("/");
  return (
    <a className="discovery-card-publisher" href={publisher.profile_url}
      title={t("Posted by {{value0}}", { value0: publisher.name })}
      aria-label={t("Posted by {{value0}}", { value0: publisher.name })}
      {...(internal
        ? { onClick: (event: React.MouseEvent<HTMLAnchorElement>) => {
            if (!onNavigate || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
            event.preventDefault();
            onNavigate(publisher.profile_url);
          } }
        : { target: "_blank", rel: "noopener noreferrer" })}>
      <span className="discovery-card-publisher-avatar" aria-hidden="true">
        {publisher.avatar_url
          ? <img src={publisher.avatar_url} alt="" width={AVATAR} height={AVATAR} loading="lazy" decoding="async" />
          : <User size={13} />}
      </span>
      <span className="discovery-card-publisher-name">{publisher.name}</span>
    </a>
  );
}
